module.exports = __webpack_public_path__ + "img/gb-whatsapp-for-ios.fb0a87a5.webp";